module.exports = __webpack_public_path__ + "close-icon-a8c3e58849f4305543fb755f575d1c58.svg";